import { createI18n } from 'vue-i18n'
import en from './en'
import zh from './zh'
import ja from './ja'
import ko from './ko'

const i18n = createI18n({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    en,
    zh,
    ja,
    ko
  }
})

export default i18n 